import React, { useState, useEffect, Component } from 'react';
import LOGO from "../../../EpicGame/Assets/images/pngwing.com.png"

const DashboardAdmin = () => {

    return (
        <div className='p-5'>
            <div className='center'>
                <img src={LOGO} className='' style={{height:'500px'}}/>
            </div>
        </div >
    );
};
export default DashboardAdmin;